import { Price } from '../catalogue-category/price.model';
import { CatalogueItem } from '../catalogue-category/catalogue-item.model';

export interface IProduct {
    discriminator: 'IProduct';
    id?: number;
    name?: string;
    price?: Price;
    quantity?: number;
    description?: string;
}

export interface IProductNavigatable {
    detailPage?: any[];
}

export interface IProductDeletable {
    // dicriminator
    iProductDeletableDiscriminator?: 'IProductDeletable';
}

export interface IProductFavoratable {
    // discriminator
    iProductFavoratableDiscriminator?: 'IProductFavoratable';
}


export const isInstanceOfProductNavigatable = (object: any): object is IProductNavigatable => object.detailPage !== undefined;

export const isInstanceOfProductDeletable = (object: any): object is IProductDeletable =>
    object.iProductDeletableDiscriminator === 'IProductDeletable';

export const isInstanceOfProductFavoratable = (object: any): object is IProductFavoratable =>
    object.iProductFavoratableDiscriminator === 'IProductFavoratable';

export const isCatalogueItem = (object: any): object is CatalogueItem => object.discriminator === 'IProduct';

export const PRODUCT_TYPE_SAMPLING_ITEM = 'sampling-item';
export const PRODUCT_TYPE_ANALYTICAL_TEST = 'analytical-test';
export const PRODUCT_TYPE_SAMPLE_SERVICE = 'lab-service';


export const isSamplingSupply = (rawProduct) => rawProduct.resourceType.search(PRODUCT_TYPE_SAMPLING_ITEM) >= 0;
export const isAnalyticalTest = (rawProduct) => rawProduct.resourceType.search(PRODUCT_TYPE_ANALYTICAL_TEST) >= 0;
export const isSampleService = (rawProduct) => rawProduct.resourceType.search(PRODUCT_TYPE_SAMPLE_SERVICE) >= 0;


